// import handleGetCompanyCreditCard from "helpers/handleGetCompanyCreditCard";
import * as Yup from "yup";

export const schemaChangePayments = Yup.object().shape({
  fullName: Yup.string().min(3).required("Full name is a required field"),
  // cardNumber: Yup.string()
  //   .matches(/^[0-9]+$/, "Must be only digits")
  //   .required()
  //   .test("credit-number", "Credit card number is invalid", (value) => {
  //     if (typeof value === "string") {
  //       let type = handleGetCompanyCreditCard(value);
  //       return !!type.length;
  //     }
  //     return false;
  //   })
  //   .min(14, "card number must be at least 14 characters")
  //   .max(16, "card number must be at most 16 characters"),
  // expirationDateMonth: Yup.string().required(
  //   "Expiration month is a required field"
  // ),
  // expirationDateYear: Yup.number()
  //   .typeError("Expiration year must be only numbers")
  //   .required("Expiration year is required")
  //   .min(
  //     new Date().getFullYear(),
  //     `Expiration year must be grater than or equal ${new Date().getFullYear()}`
  //   ),
  // cvv: Yup.string()
  //   .matches(/^[0-9]+$/, "Card cvv must be only numbers")
  //   .min(3, "Card cvv must be at least 3 numbers")
  //   .max(4, "Card cvv must be at most 4 numbers")
  //   .required("CVC is a required field"),
  address: Yup.string().required("Address is a required field"),
  city: Yup.string().required("City is a required field"),
  zip: Yup.string()
    .matches(/^[0-9]+$/, "Zip code must be only numbers")
    .min(5, "Zip code must be at least 5 characters")
    .max(5, "Zip code must be at most 5 characters")
    .required("Zip code is a required field"),
  state: Yup.string().required("State is a required field"),
  phone: Yup.string()
    .min(14, "Phone field is wrong")
    .max(14, "Phone field is wrong")
    .required("Phone is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
});
